<template>
    <div class="w100" style=" background: #01033c;">
        <article class="content-bg" style="padding-top: 40px;">
            <div class="logo-position">
                <img src="../../assets/images/ej/meetingLogo.png" alt="" srcset="" style="width: 200px">
                <p class="mt30">感谢有你</p>
                <p>共创辉煌</p>
                <div class="mt30"><span></span></div>
                <div><span></span></div>
                <div><span></span></div>
                <div><span></span></div>
            </div>
            <div class="logo-position textRight" style="right: 60px; left: auto;">
                <img src="../../assets/images/ej/meetingLogo.png" alt="" srcset="" style="width: 200px">
                <p class="mt30">感谢有你</p>
                <p>共创辉煌</p>
                <div class="mt30"><span></span></div>
                <div class=""><span></span></div>
                <div class=""><span></span></div>
                <div class=""><span></span></div>
            </div>
            <div class="wContent center">
                <div class="textCenter">
                    <img src="../../assets/images/ej/activity_boxing/2023.png" alt="" srcset="" style="width: 340px;"><br>
                    <img src="../../assets/images/2023/hangzhou/name.png" alt="" srcset="" style="width: 770px;" class="mt30">
                    <p class="title-text mt40 fontWhite">2023 · 中国 · 杭州</p>
                    <!-- <p class="title-text-en mt10 fontWhite">WITHOUT BOUNDARIES</p> -->
                    <p class="time-text textCenter center mt40">时间： 2023年7月27日，地点： 丁兰君尚云丽酒店</p>
                </div>
                <div class="center meeting-jj">
                    <p class="textCenter meeting-jj-title">会议简介</p>
                    <p>会议邀请了煤、焦、矿、钢等全产业链的钢铁生产企业、钢铁贸易企业、钢铁下游用户、金融机构和研究机构等专家和学者，围绕全球金融形势、煤焦矿行业发展以及下半年钢铁市场形势和价格运行特征等话题进行深入细致的分析和研讨。</p>
					<p>在此，我们诚垫邀请您参加!</p>
                </div>
                <div class="meeting-yt">
                    <p class="meeting-yt-title center textCenter"><span>&nbsp;会&nbsp;&nbsp;&nbsp;议&nbsp;&nbsp;&nbsp;议&nbsp;&nbsp;&nbsp;程</span></p>
                    <div class="meeting-yc-content center mt30">
                        <h2>
                            <span>下午</span><br>
                            <span>7月27日</span>
                        </h2>
						<div class="line"></div>
                        <div>
                            <p class="time-line-content">
                                <span class="fontWhite font14">13:30-14:00</span>
                                <span class="point"></span>
                                <span class="fontWhite font14">嘉宾签到</span>
                                <a class="shuline" style="height: 50px"></a>
                            </p>
                            <p class="time-line-content">
                                <span class="fontWhite font14">14:00-14:10</span>
                                <span class="point"></span>
                                <span class="fontWhite font14">致辞</span>
                                <span class="right-text">
                                    天津源泰德润钢管制造集团有限公司副总经理
                                    &nbsp;&nbsp;刘凯松 <br>
                                </span>
                                <a class="shuline" style="height: 220px;"></a>
                            </p>
                            <p class="time-line-content">
                                <span class="fontWhite font14">14:10-14:40</span>
                                <span class="point"></span>
                                <span class="fontWhite font14">
                                    致辞并演讲：《2023下半年钢铁市场形势分析》<br>
                                    <span class="right-intro">河北唐宋大数据产业股份有限公司董事长 宋雷</span>
                                </span>
                                <a class="shuline" style="height: 90px"></a>
                            </p>
                            <p class="time-line-content">
                                <span class="fontWhite font14">14:40-15:00</span>
                                <span class="point"></span>
                                <span class="fontWhite font14">
                                    演讲：《唐宋独特算法分析看市场》<br>
									<span class="right-intro">唐宋大数据市场研究院副院长 徐向南</span>
                                </span>
                                <a class="shuline" style="height: 90px"></a>
                            </p>
                            <p class="time-line-content">
                                <span class="fontWhite font14">15:00-15:20</span>
                                <span class="point"></span>
                                <span class="fontWhite font14">
                                    演讲：《全球金融局势分析展望》<br>
                                    <span class="right-intro">上海东亚期货有限公司黑色高级研究员 岳晋琛</span>
                                </span>
                                <a class="shuline" style="height: 90px"></a>
                            </p>
							<p class="time-line-content">
							    <span class="fontWhite font14">15:20-17:20</span>
							    <span class="point"></span>
							    <span class="fontWhite font14">
							        市场研讨<br>
							        <span class="right-intro"></span>
									
									<span class="fontWhite font14">
									    对话主持人：唐宋大数据市场研究院副院长<br>
										<span class="right-intro">徐向南</span>
									</span>
									
									<br/><br/>
									<span class="fontWhite font14">
									    杭州杭钢对外经济贸易有限公司 总监<br>
										<span class="right-intro">王建民</span>
									</span>
									
									<br/><br/>
									<span class="fontWhite font14">
									    上海岁金国际贸易有限公司 总经理<br>
										<span class="right-intro">李辉</span>
									</span>
									
									<br/><br/>
									<span class="fontWhite font14">
									    山西离柳焦煤集团柳林有限公司 业务经理<br>
										<span class="right-intro">王春明</span>
									</span>
									
									<br/><br/>
									<span class="fontWhite font14">
									    阿联酋阿巨玛钢管 采购部部长<br>
										<span class="right-intro">王泰锡</span>
									</span>
									
									<br/><br/>
									<span class="fontWhite font14">
									    中天钢铁集团有限公司 销售处副处长<br>
										<span class="right-intro">吴向军</span>
									</span>
									
									<br/><br/>
									<span class="fontWhite font14">
									    六安钢铁控股集团 营销中心科长<br>
										<span class="right-intro">陈利军</span>
									</span>
									
									<br/><br/>
									<span class="fontWhite font14">
									    上海西商实业有限公司 总经理<br>
										<span class="right-intro">冯强</span>
									</span>
							    </span>
							    <a class="shuline" style="height: 684px"></a>
							</p>
							<p class="time-line-content">
							    <span class="fontWhite font14">18:00-20:00</span>
							    <span class="point"></span>
							    <span class="fontWhite font14">
							        晚宴<br>
							        <span class="right-intro"></span>
							    </span>
							    <!-- <a class="shuline" style="height: 90px"></a> -->
							</p>
                        </div>                        
                    </div>
                </div>

                <div class="meeting-yt">
                    <p class="meeting-yt-title center textCenter"><span>&nbsp;嘉&nbsp;&nbsp;&nbsp;宾&nbsp;&nbsp;&nbsp;介&nbsp;&nbsp;&nbsp;绍</span></p>
					<div class="meeting-jbjs center mt40">
                        <el-row :gutter="20" class="mw-modular-box">
                            <el-col :span="8">
                                <div class="textCenter">
                                    <img src="../../assets/images/2023/hangzhou/01宋雷.png" alt="" srcset="" class="detail-user-img">
                                    <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 40px;">河北唐宋大数据产业股份有限公司<br/>董事长 宋雷</p>
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="textCenter">
                                    <img src="../../assets/images/2023/hangzhou/02叶会华.png" alt="" srcset="" class="detail-user-img">
                                    <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 40px;">叶会华</p>
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="textCenter">
                                    <img src="../../assets/images/2023/hangzhou/03吴向军.png" alt="" srcset="" class="detail-user-img">
                                    <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 40px;">中天钢铁集团有限公司<br/>销售处副处长 吴向军</p>
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="textCenter" style="margin-top: 20px">
                                    <img src="../../assets/images/2023/hangzhou/04李辉.png" alt="" srcset="" class="detail-user-img">
                                    <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 40px;">上海岁金国际贸易有限公司<br/>总经理 李辉</p>
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="textCenter" style="margin-top: 20px">
                                    <img src="../../assets/images/2023/hangzhou/05王泰锡.png" alt="" srcset="" class="detail-user-img">
                                    <p style="font-size: 15px; line-height: 30px; padding: 15px 10px; height: 40px;">阿联酋阿巨玛钢管<br/>采购部部长 王泰锡</p>
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="textCenter" style="margin-top: 20px">
                                    <img src="../../assets/images/2023/hangzhou/06王春明.png" alt="" srcset="" class="detail-user-img">
                                    <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 40px;">山西离柳焦煤集团柳林有限公司<br/>业务经理 王春明</p>
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="textCenter" style="margin-top: 20px">
                                    <img src="../../assets/images/2023/hangzhou/07冯强.png" alt="" srcset="" class="detail-user-img">
                                    <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 40px;">上海西商实业有限公司<br/>总经理 冯强</p>
                                </div>
                            </el-col>
							<el-col :span="8">
							    <div class="textCenter" style="margin-top: 20px">
							        <img src="../../assets/images/2023/hangzhou/08刘凯松.png" alt="" srcset="" class="detail-user-img">
							        <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 40px;">天津源泰德润钢管制造集团有限公司<br/>副总经理 刘凯松</p>
							    </div>
							</el-col>
							<el-col :span="8">
							    <div class="textCenter" style="margin-top: 20px">
							        <img src="../../assets/images/2023/hangzhou/09陈利军.png" alt="" srcset="" class="detail-user-img">
							        <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 40px;">六安钢铁控股集团<br/>营销中心科长 陈利军</p>
							    </div>
							</el-col>
							<el-col :span="8">
							    <div class="textCenter" style="margin-top: 20px">
							        <img src="../../assets/images/2023/hangzhou/010徐向南.png" alt="" srcset="" class="detail-user-img">
							        <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 40px;">唐宋大数据<br/>市场研究院副院长 徐向南</p>
							    </div>
							</el-col>
							<el-col :span="8">
							    <div class="textCenter" style="margin-top: 20px">
							        <img src="../../assets/images/2023/hangzhou/011岳晋琛.png" alt="" srcset="" class="detail-user-img">
							        <p style="font-size: 16px; line-height: 30px; padding: 15px 10px; height: 40px;">上海东亚期货有限公司<br/>黑色高级研究员 岳晋琛</p>
							    </div>
							</el-col>
                        </el-row>
                    </div>
                </div>

                <div class="meeting-yt">
                    <p class="meeting-yt-title center textCenter"><span>&nbsp;高&nbsp;&nbsp;&nbsp;端&nbsp;&nbsp;&nbsp;访&nbsp;&nbsp;&nbsp;谈</span></p>
                    <div id="marqueeBox" name="marqueeBox" class="index-quote-list-box">
                        <div class="inlineBlock img-box" @click="showImgDetail(0)">
                            <img src="../../assets/images/2023/hangzhou/001徐向南.png" alt="" height="150px">
                        </div>
                        <div class="inlineBlock img-box" @click="showImgDetail(1)">
                            <img src="../../assets/images/2023/hangzhou/002吴向军.png" alt="" height="150px">
                        </div>
                        <div class="inlineBlock img-box" @click="showImgDetail(2)">
                            <img src="../../assets/images/2023/hangzhou/003陈利军.png" alt="" height="150px">
                        </div>
                        <div class="inlineBlock img-box" @click="showImgDetail(3)">
                            <img src="../../assets/images/2023/hangzhou/004王建民.png" alt="" height="150px">
                        </div>
                        <div class="inlineBlock img-box" @click="showImgDetail(4)">
                            <img src="../../assets/images/2023/hangzhou/005李辉.png" alt="" height="150px">
                        </div>
                        <div class="inlineBlock img-box" @click="showImgDetail(5)">
                            <img src="../../assets/images/2023/hangzhou/006王春明.png" alt="" height="150px">
                        </div>
						<div class="inlineBlock img-box" @click="showImgDetail(6)">
						    <img src="../../assets/images/2023/hangzhou/007王泰锡.png" alt="" height="150px">
						</div>
						<div class="inlineBlock img-box" @click="showImgDetail(7)">
						    <img src="../../assets/images/2023/hangzhou/008冯强.png" alt="" height="150px">
						</div>
                    </div>
                    <el-dialog title="" :visible.sync="dialogVisible" width="40%">
                        <el-row :gutter="20">
                            <el-col :span="24">
                                <div>
                                    <img :src="dialogImg" alt="" class="w100">
                                </div>
                            </el-col>
                        </el-row>
                    </el-dialog>
                </div>

                <div class="meeting-yt">
                    <p class="meeting-yt-title center textCenter"><span>&nbsp;会&nbsp;&nbsp;&nbsp;议&nbsp;&nbsp;&nbsp;赞&nbsp;&nbsp;&nbsp;助</span></p>
                    <div class="meeting-zanzhu center textCenter">
                        <p class="zanzhu-title mt30">主办单位</p>
                        <el-row :gutter="20">
                            <el-col :span="8" :offset="8">
                                <div class="zanzhu-center">河北唐宋大数据产业股份有限公司</div>
                            </el-col>
                        </el-row>

                        <p class="zanzhu-subtitle mt30">联合主办</p>
                        <el-row :gutter="20" style="display: flex;justify-content: center;">
                            <el-col :span="8">
                                <div class="zanzhu-left">天津源泰德润钢管制造集团有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-right">上海东亚期货有限公司</div>
                            </el-col>
                        </el-row>

                        <p class="zanzhu-subtitle mt30">支持单位</p>
                        <el-row :gutter="20">
                            <el-col :span="8">
                                <div class="zanzhu-left">秦皇岛宏兴钢铁有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-center">唐山松汀钢铁有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-right">六安钢铁控股集团</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-left">浙江盛达铁塔有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-center">杭州杭钢对外经济贸易有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-right">物产中大金属集团有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-left">山西离柳焦煤集团柳林有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-center">上海西商实业有限公司</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="zanzhu-right">阿联酋阿巨玛钢管厂</div>
                            </el-col>
                        </el-row>
                    </div>
                </div>
            </div>
            <div class="meeting-yt">
                <p class="meeting-yt-title center textCenter"><span>&nbsp;大&nbsp;&nbsp;&nbsp;会&nbsp;&nbsp;&nbsp;地&nbsp;&nbsp;&nbsp;点</span></p>
                <div class="meeting-address">
                    <div style="margin-top: 40px" class="mw-modular-box fontWhite textCenter">
                        <h3 style="line-height: 40px; font-size: 24px">丁兰君尚云丽酒店</h3>
                        <p style="line-height: 40px; font-size:24px">杭州市上城区丁兰街道临丁路1188号</p>
                    </div>
                    <div class="address-bg textCenter">
                        <a href="https://map.baidu.com/poi/%E6%9D%AD%E5%B7%9E%E4%B8%81%E5%85%B0%E5%90%9B%E5%B0%9A%E4%BA%91%E9%83%A6%E9%85%92%E5%BA%97%E5%AE%B4%E4%BC%9A%E5%8E%85/@13382659.529301165,3528465.302038092,18.99z?uid=1ec1fc71944a8c2b08ccdd71&ugc_type=3&ugc_ver=1&device_ratio=2&compat=1&pcevaname=pc4.1&querytype=detailConInfo&da_src=shareurl" target="_blank">
                            <img src="../../assets/images/2023/hangzhou/背景.jpg" alt="" srcset="" class="">
                        </a>
                    </div>
                </div>
            </div>
            <div class="meeting-yt">
                <p class="meeting-yt-title center textCenter"><span>&nbsp;会&nbsp;&nbsp;&nbsp;务&nbsp;&nbsp;&nbsp;联&nbsp;&nbsp;&nbsp;系</span></p>
                <div class="meeting-concat center font16 fontWhite mt40">
                    <p class="textCenter" style="line-height: 40px;">
                        河北唐宋大数据产业股份有限公司&nbsp;&nbsp;&nbsp;&nbsp;回执传真至：0315-5921091/92<br>
                        会务联系人：王慧 18231525225&nbsp;&nbsp;&nbsp;&nbsp;路亚旭 15830588702
                    </p>
                    <el-row style="margin-top: 10px; padding-bottom: 30px;">
                        <el-col :span="8">
                            <div class="textCenter">
                                <img src="../../assets/images/act_code1.png" alt="" width="100px">
                                <small style="display: block;line-height: 40px;">在线监测预警公众号</small>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="textCenter">
                                <img src="../../assets/images/02唐宋钢铁APP.jpg" alt="" width="100px">
                                <p style="line-height: 35px;">唐宋APP</p>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="textCenter">
                                <img src="../../assets/images/03在线监测预警公众号.jpg" alt="" width="100px">
                                <p style="line-height: 35px;">在线监测预警</p>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </article>

        <ConcatsControl></ConcatsControl>
    </div>
</template>
<script>
import $ from 'jquery'
import QRCode from 'qrcode'
import '../../assets/js/jquery.liMarquee.js'
import { baseUrl, getQueryString, adIDs } from '../../assets/js/common'
import ConcatsControl from '../../templates/concatsControl'
export default {
    name: 'activitiesDetail2021gz',
    components: { ConcatsControl },
    data() {
        return {
            liMarquee: null,
            dialogVisible: false,
            dialogImg: '',
            imgs: [
                require('../../assets/images/2023/hangzhou/001徐向南.png'),
                require('../../assets/images/2023/hangzhou/002吴向军.png'),
                require('../../assets/images/2023/hangzhou/003陈利军.png'),
                require('../../assets/images/2023/hangzhou/004王建民.png'),
                require('../../assets/images/2023/hangzhou/005李辉.png'),
                require('../../assets/images/2023/hangzhou/006王春明.png'),
				require('../../assets/images/2023/hangzhou/007王泰锡.png'),
				require('../../assets/images/2023/hangzhou/008冯强.png'),
            ],
            imgsDetailNames: 
            [
                
            ],
            sjDetailData: []
        }
    },
    mounted () {
        this.id = getQueryString('id');
        this.marqueeInit();
    },
    methods: {
        marqueeInit () {
            const self = this;
            $('.index-quote-list-box').liMarquee('destroy');
            setTimeout(() => {
                $('.index-quote-list-box').liMarquee({
                    scrollamount: 120,
                    hoverstop: true,
                    circular: false
                });
            }, 500)
            
            
        },
        showImgDetail (index) {
            this.dialogImg = this.imgs[index];
            this.sjDetailData = this.imgsDetailNames[index];
            this.dialogVisible = true;
        }
    }
    
}
</script>

<style scoped>
    @import url('../../assets/css/liMarquee.css');
    .content-bg {
        background: url('../../assets/images/ej/activeTopbg.jpg') no-repeat;
        background-size: 100% auto;
        position: relative;
    }
    .logo-position {
        position: absolute;
        top: 60px;
        left: 60px;
        color: #fff;
    }
    .logo-position > p { font-size: 20px; }
    .logo-position > div > span { display: inline-block; margin-bottom: 20px; width: 8px; border-top: 2px solid #fff;}
    .mt10 { margin-top: 10px; }
    .mt40 { margin-top: 40px; }
    .mt30 { margin-top: 30px; }
    .title-text { font-size: 28px; letter-spacing: 10px; }
    .title-text-en { font-size: 20px; letter-spacing: 4px; font-weight: 100;}
    .time-text { 
        background: url('../../assets/images/ej/activeTimebg.png') no-repeat; 
        background-size: 100% 100%;
        line-height: 40px;
        width: 600px;
        font-size: 14px;
        font-weight: 600;
    }
    .meeting-jj {
        background: rgba(0, 0, 0, 0.4);
        font-size: 16px;
        color: #fff;
        line-height: 35px;
        width: 700px;
        padding: 20px 30px;
        letter-spacing: 1px;
        margin-top: 60px;
    }
    .meeting-jj-title {
        font-size: 20px;
        margin-bottom: 10px;
    }
    .meeting-yt {
        margin-top: 60px;
    }
    .meeting-yt-title {
        background: url('../../assets/images/ej/activeTitlebg.png') no-repeat;
        background-size: 100% 100%;
        width: 600px;
        height: 60px;
    }
    .meeting-yt-title span {
        background-image: -webkit-linear-gradient(bottom, #ffc67d, #f6c195, #fbdcbf); 
        -webkit-background-clip: text; 
        -webkit-text-fill-color: transparent;
        line-height: 60px;
        font-size: 30px;
        font-weight: 600;
    }
    .meeting-yc-content {
        width: 1000px;
        box-sizing: border-box;
    }
    .meeting-yc-content > h2 {
        border-left: 10px solid #024e9a;
        padding-left: 20px;
        color: #fff;
    }
    .line { border-top: 1px solid #024e9a; margin-top: 10px; }
    .time-line-content { position: relative; margin-top: 40px; }
    .time-line-content span { display: inline-block; font-size: 16px; vertical-align: top; }
    .point {
        background: url('../../assets/images/ej/activeTimePoint.png') no-repeat;
        background-size: 100% 100%;
        width: 15px;
        height: 15px;
        margin: 0 30px;
        vertical-align: bottom;
        margin-top: 4px;
    }
    .right-text {
        color: #FBFBFB;
        margin-left: 30px;
        font-weight: 600;
        line-height: 30px;
        margin-top: -5px;
		font-weight: 400;
    }
    .time-line-content .right-intro {
        color: #FBFBFB;
        font-size: 14px;
        line-height: 40px;
		font-weight: 700;
    }
    .shuline {
        position: absolute;
        height: 80px;
        border-left: 1px solid #fff;
        top: 19px;
        left: 126px;
    }
    .meeting-jbjs {
        border: 8px solid #0350a0;
        box-sizing: border-box;
        width: 1000px;
        padding: 20px;
        color: #d6be98;
    }
    .detail-user-img { width: 100%; height: 200px;  }
    .index-quote-list-box { width: 1000px; height: 360px; overflow: hidden; box-sizing: border-box; border: 8px solid #0350a0; margin: 30px auto; }
    .index-quote-list-box .img-box { padding: 30px 10px 10px 10px;  }
    .index-quote-list-box p { line-height: 40px; font-size: 16px; color: #d6be98; }
    .meeting-zanzhu { width: 1000px; }
    .zanzhu-title,
    .zanzhu-subtitle { color: #fd7744; font-size: 18px; }
    .zanzhu-subtitle { color: #ffd79f; }
    .zanzhu-left,
    .zanzhu-center,
    .zanzhu-right { line-height: 35px; width: 100%; background: url('../../assets/images/ej/one.png') no-repeat; background-size: 100% 100%; margin: 10px 0; font-size: 14px; color: #fff;}
    .zanzhu-center { background: url('../../assets/images/ej/two.png') no-repeat; background-size: 100% 100%; }
    .zanzhu-right { background: url('../../assets/images/ej/three.png') no-repeat; background-size: 100% 100%; }
    .meeting-address { padding-bottom: 30px; }
    .address-bg {
        background: url('../../assets/images/ej/addressbg.png') no-repeat;
        background-size: 100% 100%;
        padding-top: 50px;
    }
    .address-bg img { width: 1000px; }
    .meeting-concat { width: 1000px; }
</style> 